import {
	FIELDS_BY_BACKEND_ID,
	PREFERENCE_TYPES,
	DROPDOWN_FIELDS,
	MINMAX_FIELDS,
	BASICS_FIELDS,
	FIELD_TYPES,
} from "apps/global_preferences/util/constants";

const getFieldType = (fieldName) => {
	if (DROPDOWN_FIELDS.has(fieldName)) {
		return FIELD_TYPES.DROPDOWN;
	} else if (MINMAX_FIELDS.has(fieldName)) {
		return FIELD_TYPES.MIN_MAX;
	}

	return FIELD_TYPES.CHECKBOXES;
};

// Transform the API response into a lookup of { [preference.id]: preference }
// and attach useful properties to the preference like fieldName and prompt
// so the compoents don't need to compute them
export function createPreferenceLookup(preferenceCategories) {
	const transformedPrefs = {};

	preferenceCategories.forEach((category) => {
		category.category_preferences.forEach((preference) => {
			const fieldName = FIELDS_BY_BACKEND_ID[preference.id];

			const transformedPreference = {
				...preference,
				category: category.category_name,
				fieldName,
				fieldType: getFieldType(fieldName),
			};

			transformedPrefs[transformedPreference.id] = transformedPreference;
		});
	});

	return transformedPrefs;
}

// Given a preference, spit out the options that the user has chosen
export function getSelectedOptions(preference) {
	return preference.options.filter((option) => {
		return option.is_selected;
	});
}

// format a modifed preference for the api { [preferenceid]: { values: [], type: 0|1 } }
export function getSaveableChange(updatedPreference) {
	if (!updatedPreference || updatedPreference.id == null) {
		return {};
	}

	const { fieldName } = updatedPreference;

	const type = BASICS_FIELDS.has(fieldName) ? PREFERENCE_TYPES.BASICS : PREFERENCE_TYPES.SORT;
	const values = getSelectedOptions(updatedPreference).map(({ id }) => id);

	return {
		[updatedPreference.id]: {
			values,
			type,
		},
	};
}

export function updatePreferenceState(udpatedPreferenceId, updatedValues, preferences) {
	const updatedValuesLookup = updatedValues.reduce((all, v) => ({ ...all, [v]: true }), {});
	const preference = preferences[udpatedPreferenceId];

	return {
		...preferences,
		[udpatedPreferenceId]: {
			...preference,
			options: (preference.options || []).map((option) => ({
				...option,
				is_selected: updatedValuesLookup[option.id],
			})),
		},
	};
}

// Take a preference object and interpolate some new user choices
// into it
export function updatePreferenceChoices(preference, choices) {
	const updatedPreference = { ...preference };
	const updatedPreferenceOptions = updatedPreference.options.map((option) => ({
		...option,
		is_selected: choices.includes(option.id),
	}));

	return {
		...updatedPreference,
		options: updatedPreferenceOptions,
	};
}

// juggle API-style structure into something Checkbox components
// can understand
export function getCheckboxParams(preference) {
	const checkboxLabels = {};
	const checkboxOrder = [];

	preference.options.forEach((option) => {
		checkboxLabels[option.id] = option.name;
		checkboxOrder.push(option.id);
	});

	return {
		checkboxLabels,
		checkboxOrder,
	};
}

// juggle API-style structure into something OkSelect components
// can understand
export function getDropdownParams(preference) {
	const params = preference.options.map((option) => {
		return {
			name: option.name,
			value: option.id,
		};
	});

	// Prepend placeholder
	params.unshift({ name: "&mdash;", value: "&mdash;", disabled: true });

	return params;
}



// WEBPACK FOOTER //
// ./src/apps/global_preferences/util/helpers.js